// extracted by mini-css-extract-plugin
export default {"container":"MainNavigationMenu_container__9BobP","indicator":"MainNavigationMenu_indicator__FD0nf"};